import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/reportTable",
    name: "reportTable",
    redirect: {
        name: "reportTable",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/reportTable/list",
            name: "reportTableList",
            meta: {
                ...meta,
                title: "统计报表",
                cache: true,
            },
            component: () => import("@/pages/reportTable/reportTableList.vue"),
        },
    ],
};
